import { menuManager } from './menu.js';

// Menu HTML template
const menuHTML = `
<!-- Menu Button -->
<button id="menuButton" class="fixed top-4 right-4 p-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white z-[100]">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
    </svg>
</button>

<!-- Menu Modal -->
<div id="menuModal" class="fixed inset-0 bg-black/50 hidden z-[100]">
    <div class="fixed inset-0 flex items-center justify-center p-4">
        <div class="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-full max-w-md transform transition-all">
            <!-- Menu Header -->
            <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
                <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Menu</h2>
                <button id="closeMenuBtn" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <!-- Menu Content -->
            <div class="p-4">
                <!-- Theme Toggle -->
                <div class="flex items-center justify-between py-4">
                    <span class="text-gray-900 dark:text-white">Theme</span>
                    <button id="themeToggle" class="relative inline-flex h-6 w-11 items-center rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-200">
                        <span class="sr-only">Toggle theme</span>
                        <span class="absolute left-1 inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
`;

// Load menu component
async function loadMenu() {
    const menuContainer = document.getElementById('menuContainer');
    if (!menuContainer) {
        console.error('Menu container not found');
        return;
    }

    try {
        menuContainer.innerHTML = menuHTML;
        menuManager.init();
    } catch (error) {
        console.error('Error loading menu component:', error);
    }
}

// Export the loadMenu function
export { loadMenu };

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
    loadMenu();
}); 